import {AfterViewInit, Component, OnInit, ViewChild, ViewEncapsulation} from "@angular/core";
import {FormBuilder, FormControl, FormGroup, Validators} from "@angular/forms";
import {MainService} from "src/app/Services/service.service";
import {ActivatedRoute} from "@angular/router";
import {HttpClient, HttpEvent, HttpEventType, HttpHeaders, HttpParams, HttpResponse} from "@angular/common/http";
import {CaptchaService} from "../../Services/captcha.service";
import {AdvEditComponent} from "../adv-edit/adv-edit.component";

@Component({
  selector: "app-adv-manage",
  templateUrl: "./adv-manage.component.html",
  encapsulation: ViewEncapsulation.None,
  styleUrls: ["./adv-manage.component.scss"]
})
export class AdvManageComponent implements OnInit, AfterViewInit {


  constructor(public captchaService: CaptchaService, private HttpClient: HttpClient, private fb: FormBuilder, public services: MainService, private route: ActivatedRoute) {

  }

  @ViewChild("advEditComponent", {static: true}) advEdit: AdvEditComponent;

  private _advLoaded = false;

  get advLoaded(): boolean {
    return this._advLoaded;
  }

  set advLoaded(value: boolean) {
    this._advLoaded = value;
  }

  ngAfterViewInit(): void {
    const manageId = this.route.snapshot.paramMap.get("manage-id");
    if (manageId == null || "" == manageId.trim()) {
      this.services.route.navigate([""]);
    } else {
      this.services.advService.getByManageId(manageId).then(result => {
          this.advLoaded = true;
          if (result.adveristments && result.adveristments.length == 1) {
            this.advEdit.bindAdvertisement(result.adveristments[0], manageId)
          }
        }
      ).catch(res => {
        this.services.showError(res);
        this.services.route.navigate([""]);
      })
    }
  }

  ngOnInit(): void {


  }


}
